module.exports = __webpack_public_path__ + "img/public/SiteIcons/priceHoverIcon.svg?ac50786b";